// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import SEO from "@/components/SEO";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid lg:grid-cols-2">
      <SEO title="Log In" path="/login" description="Log in to your OSCR account — track your running challenges, RSVP to events and connect with the Odisha runners community." />
      <div className="hidden lg:block relative">
        <img src="https://images.pexels.com/photos/17899478/pexels-photo-17899478.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940" alt="Sadhus walking on Puri beach, Odisha" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-zinc-950 via-zinc-950/60 to-transparent" />
        <div className="relative h-full flex items-end p-12">
          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-orange-500 uppercase">OSCR · LOG IN</p>
            <h2 className="font-display text-5xl text-white mt-3 max-w-md leading-none">
              Welcome back, runner.
            </h2>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 sm:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <h1 className="font-display text-3xl text-white">Log in</h1>
          <p className="text-sm text-zinc-400 mt-1">Pick up where you left off.</p>

          <div className="mt-8 space-y-4">
            <div>
              <Label className="font-display tracking-widest text-xs text-zinc-400">EMAIL</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 rounded-none bg-zinc-900 border-zinc-800 text-white focus-visible:ring-orange-600" />
            </div>
            <div>
              <Label className="font-display tracking-widest text-xs text-zinc-400">PASSWORD</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 rounded-none bg-zinc-900 border-zinc-800 text-white focus-visible:ring-orange-600" />
            </div>
            <Button data-testid="login-submit-btn" type="submit" disabled={busy} className="w-full rounded-none bg-orange-600 hover:bg-orange-500 font-display tracking-wider text-base py-6">
              {busy ? "SIGNING IN…" : "LOG IN"}
            </Button>
          </div>

          <p className="text-sm text-zinc-400 mt-8 text-center">
            New to the pack?{" "}
            <Link to="/register" className="text-orange-500 hover:text-orange-400 font-semibold">
              Create an account
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
